import { ApiResponse } from "../interfaces/Api";
import { IPD } from "../interfaces/IpdInterface";
import { TWardType, Ward } from "../interfaces/WardInterface";
import { Delete, Get, Patch, Post } from "./apiHelper";

const wardsRoot = "/api/wards";
const ipdRoot = "/api/ipd";

export const getWards = async (props: {
  resourceCentreId: number;
  active?: boolean;
  type?: TWardType;
}): Promise<ApiResponse<Array<Ward>>> => {
  const params = new URLSearchParams();

  params.append("resourceCentreId", props.resourceCentreId.toString());
  if (props.type) params.append("type", props.type.toString());
  if (props.active !== undefined) params.append("active", props.active.toString());

  const response = await Get(`${wardsRoot}?${params.toString()}`, true);
  return response.data as ApiResponse<Array<Ward>>;
};

export const postWard = async (payload: Partial<Ward>): Promise<ApiResponse<Ward[]>> => {
  const response = await Post(wardsRoot, payload, true);
  return response.data as ApiResponse<Ward[]>;
};

export const transferIpdBed = async (
  ipdId: number,
  payload: { bedId: number; wardId: number }
): Promise<IPD> => {
  const response = await Patch(`${ipdRoot}/${ipdId}/transfer`, payload, true);
  return response.data as IPD;
};

export const transferEmergencyToIpd = async (
  ipdId: number,
  payload: { bedId: number; wardId: number }
): Promise<IPD> => {
  const response = await Patch(`${ipdRoot}/${ipdId}/transfer-to-ipd`, payload, true);
  return response.data as IPD;
};

export const updateWard = async (payload: Partial<Ward>): Promise<Ward> => {
  const response = await Patch(`${wardsRoot}/${payload.id}`, payload, true);
  return response.data as Ward;
};

// patch ward
export async function patchWard({
  id,
  data
}: {
  id: number | string;
  data: Partial<Ward>;
}): Promise<ApiResponse<Ward>> {
  const response = await Patch(`${wardsRoot}/${id}`, data, true);
  return response.data as ApiResponse<Ward>;
}

// delete ward
export async function deleteWard(id: number | string): Promise<ApiResponse<null>> {
  const response = await Delete(`${wardsRoot}/${id}`, true);
  return response.data as ApiResponse<null>;
}
